<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>

import { versionKontrol } from './api/auth'

export default {
  name: 'app',
  metaInfo: {
    title: 'Index',
    titleTemplate: '%s - Yunus Emre'
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  },
  async created () {
    try {
      await versionKontrol()
    } catch (e) {
      console.error(e)
    }
  }
}
</script>

<style>
.bv-no-focus-ring {
  width: 100%;
}
</style>
